module.exports = __webpack_public_path__ + "static/media/print-24.3eb25bf2.svg";